module.exports = __webpack_public_path__ + "static/media/w (3).97e4fe60.jpg";